import { Component, EventEmitter, Output } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-terms-of-use-modal',
  standalone: true,
  imports: [],
  templateUrl: './terms-of-use-modal.component.html',
  styleUrl: './terms-of-use-modal.component.scss'
})
export class TermsOfUseModalComponent {

  open() {
    $('#termUseModal').modal('show');
  }

  // closeModal() {
  //   this.modalClose.emit({});
  // }

}
